import React from 'react';
import {createBrowserHistory} from "history";

import './App.css';

import {Header} from "./components/header/Header";
import {Info} from "./components/info-bar/Info";
import {Footer} from "./components/footer/Footer";
import {Route, Switch} from 'react-router-dom';
import {About} from './components/content/main/About';
import {Projects} from './components/content/projects/Projects';

import style from '../src/components/content/Content.module.css'

const history = createBrowserHistory();

function App() {
  return (
    <div className="App">
        <div className="wrapper">
            <Header history={history}/>
            <Info />
              <div className={style.contentWrapper}>
                <Switch>
                  <Route history={history} exact path='/' component={About} />
                  <Route history={history} exact path='/projects' component={Projects} />
                </Switch>
              </div>
            <Footer />
        </div>
    </div>
  );
}

export default App;
